export const FIELD_WIDTH_MAP = {
  s: 3,
  m: 6,
  l: 12,
};

export const getColumnSize = (breakpoint, configKey, manifest) => {
  const defaultSize = breakpoint === 'md' ? 6 : 3;
  const propSize = manifest.config[0][configKey].width;

  return Math.max(FIELD_WIDTH_MAP[propSize] || 0, defaultSize);
};
